import React from "react";
import { Typewriter } from "react-simple-typewriter";
import { images } from "../../constants";
import "./Testimonial.scss";

const Testimonial = () => {
  return (
    <>
      <h2 className="head-text" style={{ marginTop: 50 }}>
        More about <span>me?</span> here you go!
      </h2>
      {/* background-img */}
      <div
        class="h-1/2 lg:h-screen bg-gradient-to-t from-blue-300 relative"
        style={{ marginTop: -130 }}
      >
        {/* my image */}
        <img
          class="absolute bottom-0 right-0 md:left-0 mx-auto h-5/6 object-cover"
          src={images.profile}
          alt="profile_bg.png"
        />
        <div class="absolute top-1/3 left-5 text-xl sm:left-10 sm:text-4xl md:left-1/4 md:text-6xl lg:left-5 xl:left-32 xl:text-6xl font-bold">
          <p>
            <span class="text-red-500">
              <Typewriter
                words={["FullStack", "Backend", "Frontend", "I'm creative ❤"]}
                loop={0}
                cursor
                cursorStyle="_"
                typeSpeed={70}
                deleteSpeed={50}
                delaySpeed={1000}
              />
            </span>
            <div>
              <span class="text-gray-600">Web Developer</span>
            </div>
          </p>
          <div style={{ marginTop: 50 }}>
            <a href="https://stackoverflow.com/users/18533183/ava">
              <img
                src="https://stackoverflow.com/users/flair/18533183.png"
                width="250"
                height="80"
                alt="profile for Ava at Stack Overflow, Q&amp;A for professional and enthusiast programmers"
                title="profile for Ava at Stack Overflow, Q&amp;A for professional and enthusiast programmers"
              />
            </a>
          </div>
        </div>
        {/* texts */}
        <div class="hidden lg:flex flex-col gap-5 rounded-md shadow-lg absolute top-0 bottom-0 mt-72 right-10 bg-white p-6 h-fit w-1/3">
          <h1 class="text-4xl font-bold text-indigo-900">
            Hi, I'm Ragheb Barhoumi
          </h1>
          <p class="text-gray-500 text-justify">
            I am currently a graduate from International Multidisciplinary
            School (École pluridisciplinaire internationale) University with an
            undergraduate degree in software engineer (bac+5). In my free time,
            I create a new web applications and some big projects to learn and
            improve my knowledge in web development, In my spare time when i am
            not doing web dev i am installing, testing and inspecting how
            softwares work. I am always looking to meet new and exciting people
            to work with.
          </p>
          <a
            class="bg-indigo-600 text-white text-xl px-3 py-2 rounded-sm font-semibold w-fit"
            href="https://drive.google.com/uc?export=download&id=1_gkS7eDsGLiQhDwqmyjChm54inash4ZV"
            download
          >
            Download my CV
          </a>
        </div>
      </div>
    </>
  );
};

export default Testimonial;
